export const areArraysEqualIgnoringOrder = <T>(a: readonly T[], b: readonly T[]): boolean => {
    if (a.length !== b.length) {
        return false;
    }
    const countMap = new Map<T, number>();
    for (const item of a) {
        countMap.set(item, (countMap.get(item) || 0) + 1);
    }
    for (const item of b) {
        const count = countMap.get(item);
        if (count === undefined) {
            return false;
        }
        countMap.set(item, count - 1);
        if (count - 1 === 0) {
            countMap.delete(item);
        }
    }
    return countMap.size === 0;
};
